import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16ea5306")

_pushScopeId("data-v-16ea5306")
const _hoisted_1 = { class: "group" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: ["item", { active: $props.active === 'day' }],
      to: `/report/day/${$props.equipmentId}`
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("dateType.day")), 1 /* TEXT */)
      ]),
      _: 1
    }, 8, ["class", "to"]),
    _createVNode(_component_router_link, {
      class: ["item", { active: $props.active === 'month' }],
      to: `/report/month/${$props.equipmentId}`
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("dateType.month")), 1 /* TEXT */)
      ]),
      _: 1
    }, 8, ["class", "to"])
  ]))
})